// extracted by mini-css-extract-plugin
export default {"templateCheckboxFields":"style_templateCheckboxFields__Jo8Ge","checkboxWrap":"style_checkboxWrap__ozfdl","newTemplateCheckboxFields":"style_newTemplateCheckboxFields__-N9Do"};